import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import Table from "../components/Table";

import { useEffect, useState } from "react";
import { userService } from "services/userService";
import CircularProgress from "@mui/material/CircularProgress";
import PropTypes from "prop-types";

function UserDataTable({ id }) {
  const [loading, setLoading] = useState(true);
  const columns = [
    { name: "sleutel", align: "right" },
    { name: "waarde", align: "left" },
  ];
  const [rows, setRows] = useState([]);

  useEffect(() => {
    const fetchUser = async () => {
      setLoading(true);
      try {
        const user = await userService.getUserById(id);
        setRows(
          Object.entries(user).map(([key, value]) => ({
            sleutel: (
              <MKTypography variant="button" color="text" fontWeight="bold">
                {key}
              </MKTypography>
            ),
            waarde: (
              <MKTypography variant="button" color="text">
                {String(value)}
              </MKTypography>
            ),
          }))
        );
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
      setLoading(false);
    };
    fetchUser();
  }, [id]);

  return (
    <MKBox component="section" py={3}>
      <MKTypography variant="h4">Gegevens</MKTypography>
      <MKTypography variant="body2" marginBottom={2}>
        De gegevens van de gebruiker in de gebruikersdatabase.
      </MKTypography>
      {loading ? (
        <MKBox display="flex" justifyContent="center" alignItems="center" minHeight="500px">
          <CircularProgress size={40} />
        </MKBox>
      ) : (
        <Table columns={columns} rows={rows} />
      )}
    </MKBox>
  );
}

export default UserDataTable;

UserDataTable.propTypes = {
  id: PropTypes.string.isRequired,
};
